function GetContactProjectStatusHistoryC(response) {
	var noResponse = 'No Response';
	//list of colors copied from jqplot.
	var colors = ["#4bb2c5", "#EAA228", "#c5b47f", "#579575", "#839557", "#958c12", "#953579", "#4b5de4", "#d8b83f", "#ff5800", "#0085cc", "#c747a3", "#cddf54", "#FBD178", "#26B4E3", "#bd70c7"];
	var projectStatusHistory = _.map(response,
		function (proj) {
			if (proj.ProjectStatus === '') {
				proj.ProjectStatus = noResponse;
			}
			proj.CreatedOn = PJQ.helpers.dateHelpers.getDateString(new Date(parseInt(proj.CreatedOn.substr(6))), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
			return proj;
		});

	new PJQ.templating.Template(PJQ.constants.modules.PJQADDRESSBOOK, "ProjectHistory", {
		isOldModule: true
	}).fetch(function (template) {
		var projectStatusHistoriesWithTemplates = _.map(projectStatusHistory, function (proj) {
			var renderedTemplate = jQuery(template.jsRenderTemplate.render(proj));
			jQuery('a', renderedTemplate).attr('href', '/Default.aspx?tabId=' + (settings.ProjectWallAdminTabId ? settings.ProjectWallAdminTabId : settings.ProjectWallTabId) + '&projectid=' + proj.ProjectId); //tabId=123682849
			return {
				project: proj,
				template: renderedTemplate
			};
		});

		var projectList = jQuery("#dialog-project-history ul");
		projectList.empty();
		jQuery('#phPie').empty();
		jQuery('#phBar').empty();
		_.each(projectStatusHistoriesWithTemplates, function (item) {
			projectList.append(item.template);
		});
		//jQuery("#divGrid").addClass('pjq-hidden');
		//jQuery("#dialog-project-history").show();
		jQuery('#dialog-project-history').dialog({
			title: "Project Status History",
			modal: true,
			resizable: false,
			width: 850,
			//dialogClass: 'reportContactDialog',
			open: function () {
			}
		});

		var numberOfNoReplies = _.filter(projectStatusHistory, function (proj) {
				return proj.ProjectStatus === noResponse;
			}).length,
			pieData = [
				[noResponse, numberOfNoReplies],
				['Responded', projectStatusHistory.length - numberOfNoReplies]
			],
			barChartData = _.countBy(projectStatusHistory, "ProjectStatus"),
			barChartLabels = _.keys(barChartData),
			barChartValues = _.values(barChartData);

		var pieChart = jQuery.jqplot('phPie', [pieData], {
			seriesDefaults: {
				// Make this a pie chart.
				renderer: jQuery.jqplot.PieRenderer,
				rendererOptions: {
					// Put data labels on the pie slices.
					// By default, labels show the percentage of the slice.
					showDataLabels: true
				}
			},
			legend: {
				show: true,
				location: 'e'
			},
			title: 'Responses'
		});

		$.jqplot.config.enablePlugins = true;

		var barChart = $.jqplot('phBar', [barChartValues], {
			seriesDefaults: {
				renderer: $.jqplot.BarRenderer,
				rendererOptions: {
					varyBarColor: true
				},
				pointLabels: {
					show: true
				},
			},
			title: 'Response Statuses',
			axes: {
				xaxis: {
					renderer: $.jqplot.CategoryAxisRenderer,
					ticks: barChartLabels
				}
			}
		});

		var allProjects = jQuery('li', projectList);
		var statusName;
		$('#phBar').bind('jqplotDataMouseOver',
			function (ev, seriesIndex, pointIndex, data) {
				allProjects.css('background-color', 'white');
				statusName = barChartLabels[pointIndex];
				_.each(projectStatusHistoriesWithTemplates, function (item) {
					if (item.project.ProjectStatus === statusName) {
						item.template.css('background-color', colors[pointIndex]);
					}
				});
			});
		$('#phPie').bind('jqplotDataMouseOver',
			function (ev, seriesIndex, pointIndex, data) {
				allProjects.css('background-color', 'white');
				statusName = pieData[pointIndex][0]; //the status is the first in the array
				if (statusName === noResponse) {
					_.each(projectStatusHistoriesWithTemplates, function (item) {
						if (item.project.ProjectStatus === statusName) {
							item.template.css('background-color', colors[pointIndex]);
						}
					});
				}
				else {
					_.each(projectStatusHistoriesWithTemplates, function (item) {
						if (item.project.ProjectStatus !== noResponse) {
							item.template.css('background-color', colors[pointIndex]);
						}
					});
				}
			});
	});
}